import script from "./CourseStudentList.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseStudentList.vue?vue&type=script&setup=true&lang=js"

import "./CourseStudentList.vue?vue&type=style&index=0&id=652de124&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652de124"]])

export default __exports__